export default __webpack_public_path__ + "static/media/CNHS-3.0,0.27d5bbea.png";